// primitives.jsx — small reusable bits: Tag, KPI, Sparkline, Flag
import React from 'react';
import { FLAG_COLORS, FLAG_FALLBACK } from "./flagColors";

export function Tag({ kind = 'neutral', dot, children, style }) {
  return (
    <span className={`tag ${kind}${dot ? ' dot' : ''}`} style={style}>
      {children}
    </span>
  );
}

export function Sparkline({ data, color = 'var(--brand-primary)', w = 88, h = 28 }) {
  const min = Math.min(...data),
    max = Math.max(...data);
  const range = max - min || 1;
  const stepX = w / (data.length - 1);
  const pts = data
    .map((v, i) => `${(i * stepX).toFixed(1)},${(h - ((v - min) / range) * h).toFixed(1)}`)
    .join(' ');
  return (
    <svg className="spark" width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
      <polyline
        points={pts}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function KPI({ label, value, delta, deltaDir = 'up', trend, icon }) {
  const Icon = icon;
  return (
    <div className="kpi">
      <div className="label">
        {Icon ? <Icon /> : null}
        {label}
      </div>
      <div className="val">{value}</div>
      {delta && (
        <div className={`delta ${deltaDir}`}>
          {deltaDir === 'up' ? '▲' : '▼'} {delta}
        </div>
      )}
      {trend && (
        <Sparkline
          data={trend}
          color={deltaDir === 'down' ? 'var(--err)' : 'var(--brand-primary)'}
        />
      )}
    </div>
  );
}

export function Flag({ code }) {
  // tiny country code chip — placeholder, no flag art
  return (
    <span className="flag" style={{ background: FLAG_COLORS[code] || FLAG_FALLBACK }}>
      {code}
    </span>
  );
}
